import React, { Fragment, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import { WhitePanelWithHeader } from "../../ui";
import CommercialDealEventInformation from "../../pages/admin/corporate/events/components/CommercialDealEventInformation";
import Loading from "../Loading";

const CommercialDeals = ({ label, expanded, enquiryVenueDataId, token }) => {
  const [commercialDeal, setCommercialDeal] = useState([]);
  const [panelOpen, setPanelOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    return () => setCommercialDeal([]);
  }, []);

  useEffect(() => {
    if (panelOpen) {
      getCommercialDeal();
    } else {
      setCommercialDeal([]);
    }
  }, [panelOpen]);

  const togglePanel = () => {
    setPanelOpen(!panelOpen);
  };

  const getCommercialDeal = async () => {
    setLoading(true);
    await axios
      .get(
        `${window.API}/rfp/enquiry-data/${enquiryVenueDataId}/commercial-deal`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(({ data }) => {
        setCommercialDeal(data);
        setLoading(false);
      })
      .catch(error => console.error(error));
  };

  return (
    <WhitePanelWithHeader
      collapsible
      expanded={expanded}
      open={panelOpen}
      onToggle={togglePanel}
      title={label ? label : "Commercial Deal"}
      icon="far fa-user"
    >
      {commercialDeal ? (
        <CommercialDealEventInformation commercialDeal={commercialDeal} />
      ) : (
        <Fragment>
          <p>There are no commercial deals applied to this enquiry.</p>
        </Fragment>
      )}
    </WhitePanelWithHeader>
  );
};

export default CommercialDeals;
